import Immutable from 'immutable';
import { combineReducers } from 'redux-immutablejs';

import category from './browseCategoryReducer';
import home from './browseHomeReducer';

export default combineReducers(
  Immutable.Map({
    category,
    home
  })
);
